import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { CampaignTriggerType } from '@dev/ee-api/ee-api-models';
import { Typography } from '@dev/ee-components';

import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { useCampaignScreensPathsChecker } from '../../../hooks/useCampaignScreensPathsChecker';
import { ScheduleOptions } from '../../../ScheduleOptions';

import { SectionWrapperStep3 } from '../../../styled';

export const ScheduleCampaign = (): JSX.Element => {
    const { t } = useTranslation();
    const { campaign } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    if (!isDetailsScreen || campaign?.TriggerOptions?.Type !== CampaignTriggerType.FutureScheduled) {
        return null;
    }

    return (
        <SectionWrapperStep3>
            <Typography variant="h2" style={{ paddingBottom: 24 }}>
                {t('schedulecampaign')}
            </Typography>
            <ScheduleOptions />
        </SectionWrapperStep3>
    );
};
